module.exports = __webpack_public_path__ + "Banner_ExerciseExploration-57f5b9ff559a61b4388050d7bbd08815.svg";